export const FOOTER_MENUS = [
  ['Products', 'Designers', 'Features', 'Sales'],
  [
    'About Us',
    'Contact',
    'Press',
    'Store Location',
    'Shipping Information',
    'Returns & Exchanges',
  ],
];
